import gsap from "gsap/all";
import Flip from "gsap/Flip";

gsap.registerPlugin(Flip);

export default () => ({
  snapToTop: false,
  logoShouldShrink: false,
  headerHeight: document.querySelector(".header") ? document.querySelector(".header").clientHeight : 0,
  metaNavHeight: document.querySelector(".meta-nav") ? document.querySelector(".meta-nav").clientHeight : 0,
  _breakpoint: window.matchMedia("(min-width: 1024px)"),
  duration: 0.175,

  init() {
    this.logoShouldShrink = document.querySelector(
      ".header .logo-should-shrink"
    );

    this.reverseHeader();
    this._bindRequestAnimationFrame();
    this._breakpoint.addListener(this.setLogoSize.bind(this));
    this.setLogoSize();

    // let mql = window.matchMedia('(min-width: 1024px)');
    // const navigationBreakpoint = window.matchMedia("(min-width: 1024px)");
    // navigationBreakpoint.addListener(
    //   this.closeNavigationOnBreakpointChange.bind(this)
    // );
  },

  _bindRequestAnimationFrame() {
    window.requestAnimationFrame(this._bindRequestAnimationFrame.bind(this));
    this._handleScroll();
  },

  setLogoSize() {
    if (this.logoShouldShrink) {
      if (this._breakpoint.matches) {
        gsap.to(".logo-should-shrink", {
          height: 80,
          duration: 0.3,
        });
      } else {
        gsap.to(".logo-should-shrink", {
          height: 50,
          duration: 0.3,
        });
      }
    }
  },

  _handleScroll() {
    // add 5 pixel to prevent stuttering of caused by position sticky
    const snapToTop = window.scrollY >= this.metaNavHeight + 5;

    if (snapToTop !== this.snapToTop && snapToTop) {
      this.snapToTop = snapToTop;
      this.animateHeader();
    }

    if (snapToTop !== this.snapToTop && !snapToTop) {
      this.snapToTop = snapToTop;
      this.reverseHeader();
    }
  },

  animateHeader() {
    const state = Flip.getState(".main-nav");

    document.querySelector("header").classList.add("scrolled");
    if (this._breakpoint.matches) {
      document.querySelector(
        "main"
      ).style.paddingTop = `${this.headerHeight}px`;
    }

    this.flip(state);

    if (this.logoShouldShrink) {
      const logoHeight = this._breakpoint.matches ? 80 : 50;

      gsap.to(".header .logo-should-shrink", {
        height: logoHeight * 0.6,
        duration: this.duration,
      });
    }
  },

  reverseHeader() {
    const state = Flip.getState(".main-nav");

    document.querySelector("header").classList.remove("scrolled");
    if (this._breakpoint.matches) {
      document.querySelector("main").style.paddingTop = null;
    }

    this.flip(state);

    if (this.logoShouldShrink) {
      const logoHeight = this._breakpoint.matches ? 80 : 50;

      gsap.to(".header .logo-should-shrink", {
        height: logoHeight,
        duration: this.duration,
      });
    }
  },

  flip(state) {
    Flip.from(state, {
      simple: true,
      nested: true,
      duration: this.duration,
    });
  },
});
